import { bffApi } from '../../../services/bff/bffApi';

import { NpsEligibility, NpsAnswerPayload, NpsDismissalPayload } from '../types';

export class NpsAnswerService {
  private readonly baseUrl = `/api/struct/v1/nps`;

  getEligibility = async (businessId: number, userId?: string): Promise<NpsEligibility | null> => {
    try {
      const { data } = await bffApi.get<NpsEligibility>(
        `${this.baseUrl}/eligibility`,
        { params: { businessId, userId } }
      );

      return data?.eligible && data.question ? data : null;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  createAnswer = async (payload: NpsAnswerPayload): Promise<void> => {
    await bffApi.post(`${this.baseUrl}/answers`, payload);
  };

  createDismissal = async (payload: NpsDismissalPayload): Promise<void> => {
    try {
      await bffApi.post(`${this.baseUrl}/dismissals`, payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
}
